var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container cards-filter-buttons" }, [
      _c(
        "div",
        {
          staticClass:
            "mb-4 lg:relative lg:flex lg:justify-between lg:items-end"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "header-right hidden lg:block lg:w-auto" }, [
            _c("div", { staticClass: "extra-filters" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.hidefilter,
                      expression: "hidefilter"
                    }
                  ],
                  staticClass: "dpd-filter w-full sm:w-auto"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "filter-button w-full pl-16",
                      class: { active: this.deelnemerTrayOpened },
                      attrs: { id: "extrafilter-desk" },
                      on: {
                        click: function($event) {
                          return _vm.toggleDeelnemerTray()
                        }
                      }
                    },
                    [
                      _vm.filtersCount > 0
                        ? _c("div", { staticClass: "flex font-semibold" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-1/6 sm:w-1/3 bg-bluePersian text-white p-3 flex justify-center items-center"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.filtersCount) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        : _c(
                            "div",
                            {
                              staticClass:
                                "px-4 py-4 flex justify-center font-semibold text-bluePersian"
                            },
                            [
                              _c("img", {
                                staticClass: "mr-2",
                                attrs: {
                                  src: require("../../images/icon-filters-blue.svg"),
                                  alt: ""
                                }
                              }),
                              _vm._v(
                                "\n                Uitgebreid zoeken\n              "
                              )
                            ]
                          )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "absolute dpd-filter_tray last-child-mb-0 p-3 xs:p-6 lg:p-3 xl:p-8 bg-blueLight",
                      class: { hidden: !this.deelnemerTrayOpened },
                      attrs: { id: "extrafilter_tray-desk" }
                    },
                    [
                      _c("div", { staticClass: "filters-layout mb-6" }, [
                        _c(
                          "div",
                          { staticClass: "dagBijz-section filter-group-desk" },
                          [
                            _c(
                              "h4",
                              { staticClass: "mb-2 text-18px font-bold" },
                              [_vm._v("Dag")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.dagOptions, function(dag, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "sm:whitespace-normal flex items-start text-16px mb-3"
                                },
                                [
                                  _c("input", {
                                    attrs: {
                                      type: "checkbox",
                                      name: "dagfilter" + index,
                                      id: "dagfilter" + index
                                    },
                                    domProps: {
                                      checked: _vm.checkIfSelected(
                                        "whd_event_dates",
                                        dag.value
                                      ),
                                      value: dag.longLabel
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectFilter(
                                          "whd_event_dates",
                                          dag.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    attrs: { for: "dagfilter" + index }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    class: {
                                      active: _vm.checkIfSelected(
                                        "whd_event_dates",
                                        dag.value
                                      )
                                    },
                                    attrs: { for: "dagfilter" + index },
                                    domProps: {
                                      innerHTML: _vm._s(dag.longLabel)
                                    }
                                  })
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "excursie-section filter-group-desk" },
                          [
                            _c(
                              "h4",
                              { staticClass: "mb-2 text-18px font-bold" },
                              [_vm._v("Type Excursie")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.eventOptions.excursie, function(
                              excursie,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "sm:whitespace-normal flex items-start text-16px mb-3"
                                },
                                [
                                  _c("input", {
                                    attrs: {
                                      type: "checkbox",
                                      name: "excursiefilter" + index,
                                      id: "excursiefilter" + index
                                    },
                                    domProps: {
                                      checked: _vm.checkIfSelected(
                                        "excursie",
                                        excursie.term_id
                                      ),
                                      value: excursie.term_id
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectFilter(
                                          "excursie",
                                          excursie.term_id
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    attrs: { for: "excursiefilter" + index }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    class: {
                                      active: _vm.checkIfSelected(
                                        "excursie",
                                        excursie.term_id
                                      )
                                    },
                                    attrs: { for: "excursiefilter" + index },
                                    domProps: {
                                      innerHTML: _vm._s(excursie.name)
                                    }
                                  })
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "programma-section filter-group-desk"
                          },
                          [
                            _c(
                              "h4",
                              { staticClass: "mb-2 text-18px font-bold" },
                              [_vm._v("Type programma")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.eventOptions.programma, function(
                              programma,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "sm:whitespace-normal text-16px mb-3"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "relative flex items-start"
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          name: "programmafilter" + index,
                                          id: "programmafilter" + index
                                        },
                                        domProps: {
                                          checked: _vm.checkIfSelected(
                                            "programma",
                                            programma.term_id
                                          ),
                                          value: programma.term_id
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectFilter(
                                              "programma",
                                              programma.term_id
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        attrs: {
                                          for: "programmafilter" + index
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        class: {
                                          active: _vm.checkIfSelected(
                                            "programma",
                                            programma.term_id
                                          )
                                        },
                                        attrs: {
                                          for: "programmafilter" + index
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(programma.name)
                                        }
                                      }),
                                      _vm._v(" "),
                                      Object.values(programma.children).length >
                                      0
                                        ? _c("img", {
                                            staticClass:
                                              "absolute right-0 cursor-pointer",
                                            class: {
                                              "transform rotate-180":
                                                _vm.childCheckboxOpened
                                            },
                                            attrs: {
                                              src: require("../../images/icon-chevron-checkbox.svg"),
                                              alt: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleChildCheckbox()
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  Object.values(programma.children).length > 0
                                    ? _c(
                                        "div",
                                        {
                                          class: {
                                            hidden: !_vm.childCheckboxOpened
                                          }
                                        },
                                        _vm._l(
                                          Object.values(programma.children),
                                          function(child, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "flex items-start ml-8 mt-3"
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "checkbox",
                                                    name:
                                                      "child_programma-" +
                                                      child.parent +
                                                      "-" +
                                                      index,
                                                    id:
                                                      "child_programma-" +
                                                      child.parent +
                                                      "-" +
                                                      index
                                                  },
                                                  domProps: {
                                                    checked: _vm.checkIfSelected(
                                                      "programma",
                                                      child.term_id
                                                    ),
                                                    value: child.term_id
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.selectFilter(
                                                        "programma",
                                                        child.term_id
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("label", {
                                                  attrs: {
                                                    for:
                                                      "child_programma-" +
                                                      child.parent +
                                                      "-" +
                                                      index
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("label", {
                                                  class: {
                                                    active: _vm.checkIfSelected(
                                                      "programma",
                                                      child.term_id
                                                    )
                                                  },
                                                  attrs: {
                                                    for:
                                                      "child_programma-" +
                                                      child.parent +
                                                      "-" +
                                                      index
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      child.name
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e()
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "Bijz-section filter-group-desk" },
                          [
                            _c(
                              "h4",
                              { staticClass: "mb-2 text-18px font-bold" },
                              [_vm._v("Bijzonderheden")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.detailsOptions, function(detail, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "sm:whitespace-normal flex items-start text-16px mb-3"
                                },
                                [
                                  _c("input", {
                                    attrs: {
                                      type: "checkbox",
                                      name: "detailfilter" + index,
                                      id: "detailfilter" + index
                                    },
                                    domProps: {
                                      checked: _vm.checkIfSelected(
                                        "details",
                                        detail.value
                                      ),
                                      value: detail.value
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectFilter(
                                          "details",
                                          detail.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    attrs: { for: "detailfilter" + index }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    class: {
                                      active: _vm.checkIfSelected(
                                        "details",
                                        detail.value
                                      )
                                    },
                                    attrs: { for: "detailfilter" + index },
                                    domProps: {
                                      innerHTML: _vm._s(detail.label)
                                    }
                                  })
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.tickets_sales_start
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "beschikbaar-section filter-group-desk"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "sm:whitespace-normal flex items-start text-16px mb-3"
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        type: "checkbox",
                                        name: "beschikbaarFilter_desk",
                                        id: "beschikbaarFilter_desk",
                                        value: "beschikbaar"
                                      },
                                      domProps: {
                                        checked: _vm.checkIfSelected(
                                          "whd_ticketavailable",
                                          "beschikbaar"
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectFilter(
                                            "whd_ticketavailable",
                                            "beschikbaar"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      attrs: { for: "beschikbaarFilter_desk" }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      class: {
                                        active: _vm.checkIfSelected(
                                          "whd_ticketavailable",
                                          "beschikbaar"
                                        )
                                      },
                                      attrs: { for: "beschikbaarFilter_desk" },
                                      domProps: {
                                        innerHTML: _vm._s("Tickets beschikbaar")
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "doelgroep-section filter-group-desk"
                          },
                          [
                            _c(
                              "h4",
                              { staticClass: "mb-2 text-18px font-bold" },
                              [_vm._v("Doelgroep")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.eventOptions.doelgroep, function(
                              doel,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass:
                                    "sm:whitespace-normal flex items-start text-16px mb-3"
                                },
                                [
                                  _c("input", {
                                    attrs: {
                                      type: "checkbox",
                                      name: "doelgroepfilter" + index,
                                      id: "doelgroepfilter" + index
                                    },
                                    domProps: {
                                      checked: _vm.checkIfSelected(
                                        "doelgroep",
                                        doel.term_id
                                      ),
                                      value: doel.term_id
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectFilter(
                                          "doelgroep",
                                          doel.term_id
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    attrs: { for: "doelgroepfilter" + index }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    class: {
                                      active: _vm.checkIfSelected(
                                        "doelgroep",
                                        doel.term_id
                                      )
                                    },
                                    attrs: { for: "doelgroepfilter" + index },
                                    domProps: { innerHTML: _vm._s(doel.name) }
                                  })
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "filters-dropdown hidden",
                          class: { active: _vm.deelnemerDropdown }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "deelnemers-header py-6 flex justify-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "deelnemers-btn flex cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleDeelnemerFilters()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "h4",
                                    { staticClass: "mb-0 text-18px font-bold" },
                                    [
                                      _vm._v(
                                        "\n                      Bekijk excursiedeelnemers\n                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass:
                                      "ml-2 transition-all duration-300 transform",
                                    class: {
                                      "-rotate-180": _vm.deelnemerDropdown
                                    },
                                    attrs: {
                                      src: require("../../images/icon-chevron-darkBlue-down.svg"),
                                      alt: ""
                                    }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "deelnemers-filters mb-6" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "deelnemers1-column filter-group-desk"
                                },
                                _vm._l(_vm.deelnemers1, function(deel, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "sm:whitespace-normal flex items-start text-16px mb-3"
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          name: "deelfilter1" + index,
                                          id: "deelfilter1" + index
                                        },
                                        domProps: {
                                          checked: _vm.checkIfSelected(
                                            "deelnemers",
                                            deel.deelnemerid
                                          ),
                                          value: deel.deelnemerid
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectFilter(
                                              "deelnemers",
                                              deel.deelnemerid
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        attrs: { for: "deelfilter1" + index }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        class: {
                                          active: _vm.checkIfSelected(
                                            "deelnemers",
                                            deel.deelnemerid
                                          )
                                        },
                                        attrs: { for: "deelfilter1" + index },
                                        domProps: {
                                          innerHTML: _vm._s(deel.title)
                                        }
                                      })
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "deelnemers2-column filter-group-desk"
                                },
                                _vm._l(_vm.deelnemers2, function(deel, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "sm:whitespace-normal flex items-start text-16px mb-3"
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          name: "deelfilter2" + index,
                                          id: "deelfilter2" + index
                                        },
                                        domProps: {
                                          checked: _vm.checkIfSelected(
                                            "deelnemers",
                                            deel.deelnemerid
                                          ),
                                          value: deel.deelnemerid
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectFilter(
                                              "deelnemers",
                                              deel.deelnemerid
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        attrs: { for: "deelfilter2" + index }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        class: {
                                          active: _vm.checkIfSelected(
                                            "deelnemers",
                                            deel.deelnemerid
                                          )
                                        },
                                        attrs: { for: "deelfilter2" + index },
                                        domProps: {
                                          innerHTML: _vm._s(deel.title)
                                        }
                                      })
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "deelnemers3-column filter-group-desk"
                                },
                                _vm._l(_vm.deelnemers3, function(deel, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "sm:whitespace-normal flex items-start text-16px mb-3"
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          type: "checkbox",
                                          name: "deelfilter3" + index,
                                          id: "deelfilter3" + index
                                        },
                                        domProps: {
                                          checked: _vm.checkIfSelected(
                                            "deelnemers",
                                            deel.deelnemerid
                                          ),
                                          value: deel.deelnemerid
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectFilter(
                                              "deelnemers",
                                              deel.deelnemerid
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        attrs: { for: "deelfilter3" + index }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        class: {
                                          active: _vm.checkIfSelected(
                                            "deelnemers",
                                            deel.deelnemerid
                                          )
                                        },
                                        attrs: { for: "deelfilter3" + index },
                                        domProps: {
                                          innerHTML: _vm._s(deel.title)
                                        }
                                      })
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "filters-form flex items-center justify-end"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "right-side w-full sm:w-auto flex items-center"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-1/3 px-4 sm:w-auto text-gulfBlue font-semibold lg:font-bold hover:opacity-50 focus:outline-none",
                                  on: {
                                    click: function($event) {
                                      return _vm.clearAllFilters("desktop")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    Filters wissen\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-2/3 sm:w-auto bg-gulfBlue py-2 lg:py-4 px-3 lg:px-6 text-white font-semibold lg:font-bold ml-4 focus:outline-none",
                                  on: {
                                    click: function($event) {
                                      return _vm.loadProgrammes(false, true)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "hover:opacity-75" },
                                    [_vm._v("Filters toepassen")]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      this.eventOptions.programma
        ? _c(
            "div",
            { staticClass: "-mx-4 flex flex-wrap items-end justify-between" },
            [
              _c("div", { staticClass: "px-4 w-full mb-0" }, [
                _c("div", { staticClass: "sm:relative flex justify-between" }, [
                  _c(
                    "div",
                    {
                      staticClass: "dagfilters-left hidden sm:block sm:w-auto"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "toon-alleen-btn filter-button cursor-pointer",
                          attrs: { id: "toon-alleen-desk" },
                          on: {
                            click: function($event) {
                              return _vm.selectFilter(null, "all", true)
                            }
                          }
                        },
                        [_vm._v("\n              Toon alleen\n            ")]
                      ),
                      _vm._v(" "),
                      _vm._l(this.dagOptions, function(dag, index) {
                        return _c(
                          "button",
                          {
                            key: index,
                            staticClass: "exclusive-filters",
                            class: [
                              "orange-hover cursor-pointer",
                              {
                                dateSelected: _vm.checkIfSelected(
                                  "whd_event_dates",
                                  dag.value
                                )
                              }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.selectFilter(
                                  "whd_event_dates",
                                  dag.value,
                                  true
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(dag.shortLabel) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.tickets_sales_start
                        ? _c("div", { staticClass: "hidden lg:inline-block" }, [
                            _c(
                              "button",
                              {
                                staticClass: "exclusive-filters",
                                class: [
                                  "lightblue-hover cursor-pointer",
                                  {
                                    beschikbaarSelected: _vm.checkIfSelected(
                                      "whd_ticketavailable",
                                      "beschikbaar"
                                    )
                                  }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.selectFilter(
                                      "whd_ticketavailable",
                                      "beschikbaar",
                                      true
                                    )
                                  },
                                  mouseover: function($event) {
                                    _vm.hoveredExFilter = "beschikbaar"
                                  },
                                  mouseleave: function($event) {
                                    _vm.hoveredExFilter = undefined
                                  }
                                }
                              },
                              [
                                _vm.checkIfSelected(
                                  "whd_ticketavailable",
                                  "beschikbaar"
                                ) === undefined &&
                                _vm.hoveredExFilter === "beschikbaar"
                                  ? [
                                      _c("img", {
                                        staticClass: "mr-2 w-6 hovered",
                                        attrs: { src: _vm.ticketIcons.blue }
                                      })
                                    ]
                                  : [
                                      _vm.checkIfSelected(
                                        "whd_ticketavailable",
                                        "beschikbaar"
                                      )
                                        ? _c("img", {
                                            staticClass: "mr-2 w-6 clicked",
                                            attrs: {
                                              src: _vm.ticketIcons.blue,
                                              alt: ""
                                            }
                                          })
                                        : _c("img", {
                                            staticClass: "mr-2 w-6 clicked",
                                            attrs: {
                                              src: _vm.ticketIcons.grey,
                                              alt: ""
                                            }
                                          })
                                    ],
                                _vm._v(
                                  "\n                Tickets beschikbaar\n              "
                                )
                              ],
                              2
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "extrafilters-right w-full sm:w-auto lg:hidden"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "dpd-filter w-full sm:w-auto" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "filter-button w-full pl-16",
                              class: { active: this.deelnemerMobileTrayOpened },
                              attrs: { id: "extrafilter-mobi" },
                              on: {
                                click: function($event) {
                                  return _vm.toggleDeelnemerMobileTray()
                                }
                              }
                            },
                            [
                              _vm.filtersCount > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "flex h-full font-semibold"
                                    },
                                    [
                                      _vm._m(2),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-1/6 bg-bluePersian text-white lg:px-3 flex justify-center items-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.filtersCount) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "px-2 h-full flex items-center justify-center font-semibold text-bluePersian"
                                    },
                                    [
                                      _vm._m(3),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "block sm:hidden whitespace-no-wrap"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Filters\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "hidden sm:block whitespace-no-wrap"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Uitgebreid zoeken\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "dpd-filter_tray last-child-mb-0 p-3 xs:p-6 lg:p-3 xl:p-8 bg-blueLight",
                              class: {
                                hidden: !this.deelnemerMobileTrayOpened
                              },
                              attrs: { id: "extrafilter_tray-mobi" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "filters-layout mb-6" },
                                [
                                  _vm.tickets_sales_start
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "beschikbaar-section filter-group"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "sm:whitespace-normal flex items-start text-16px mb-3"
                                            },
                                            [
                                              _c("input", {
                                                attrs: {
                                                  type: "checkbox",
                                                  name:
                                                    "beschikbaarFilter_mobi",
                                                  id: "beschikbaarFilter_mobi",
                                                  value: "beschikbaar"
                                                },
                                                domProps: {
                                                  checked: _vm.checkIfSelected(
                                                    "whd_ticketavailable",
                                                    "beschikbaar"
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.selectFilter(
                                                      "whd_ticketavailable",
                                                      "beschikbaar"
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("label", {
                                                attrs: {
                                                  for: "beschikbaarFilter_mobi"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("label", {
                                                class: {
                                                  active: _vm.checkIfSelected(
                                                    "whd_ticketavailable",
                                                    "beschikbaar"
                                                  )
                                                },
                                                attrs: {
                                                  for: "beschikbaarFilter_mobi"
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    "Tickets beschikbaar"
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "dag-section filter-group" },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "mb-2 text-18px font-bold"
                                        },
                                        [_vm._v("Dag")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.dagOptions, function(
                                        dag,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "sm:whitespace-normal flex items-start text-16px mb-3"
                                          },
                                          [
                                            _c("input", {
                                              attrs: {
                                                type: "checkbox",
                                                name: "dagfilter" + index,
                                                id: "dagfilter" + index
                                              },
                                              domProps: {
                                                checked: _vm.checkIfSelected(
                                                  "whd_event_dates",
                                                  dag.value
                                                ),
                                                value: dag.longLabel
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectFilter(
                                                    "whd_event_dates",
                                                    dag.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              attrs: {
                                                for: "dagfilter" + index
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              class: {
                                                active: _vm.checkIfSelected(
                                                  "whd_event_dates",
                                                  dag.value
                                                )
                                              },
                                              attrs: {
                                                for: "dagfilter" + index
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(dag.longLabel)
                                              }
                                            })
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "excursie-section filter-group-desk"
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "mb-2 text-18px font-bold"
                                        },
                                        [_vm._v("Type Excursie")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.eventOptions.excursie,
                                        function(excursie, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "sm:whitespace-normal flex items-start text-16px mb-3"
                                            },
                                            [
                                              _c("input", {
                                                attrs: {
                                                  type: "checkbox",
                                                  name:
                                                    "excursiefilter_mobi" +
                                                    index,
                                                  id:
                                                    "excursiefilter_mobi" +
                                                    index
                                                },
                                                domProps: {
                                                  checked: _vm.checkIfSelected(
                                                    "excursie",
                                                    excursie.term_id
                                                  ),
                                                  value: excursie.term_id
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.selectFilter(
                                                      "excursie",
                                                      excursie.term_id
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("label", {
                                                attrs: {
                                                  for:
                                                    "excursiefilter_mobi" +
                                                    index
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("label", {
                                                class: {
                                                  active: _vm.checkIfSelected(
                                                    "excursie",
                                                    excursie.term_id
                                                  )
                                                },
                                                attrs: {
                                                  for:
                                                    "excursiefilter_mobi" +
                                                    index
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    excursie.name
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "programma-section filter-group"
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "mb-2 text-18px font-bold"
                                        },
                                        [_vm._v("Type programma")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.eventOptions.programma,
                                        function(programma, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "sm:whitespace-normal text-16px mb-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "relative flex items-start"
                                                },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      name:
                                                        "programmafilter" +
                                                        index,
                                                      id:
                                                        "programmafilter" +
                                                        index
                                                    },
                                                    domProps: {
                                                      checked: _vm.checkIfSelected(
                                                        "programma",
                                                        programma.term_id
                                                      ),
                                                      value: programma.term_id
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.selectFilter(
                                                          "programma",
                                                          programma.term_id
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("label", {
                                                    attrs: {
                                                      for:
                                                        "programmafilter" +
                                                        index
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("label", {
                                                    class: {
                                                      active: _vm.checkIfSelected(
                                                        "programma",
                                                        programma.term_id
                                                      )
                                                    },
                                                    attrs: {
                                                      for:
                                                        "programmafilter" +
                                                        index
                                                    },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        programma.name
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  Object.values(
                                                    programma.children
                                                  ).length > 0
                                                    ? _c("img", {
                                                        staticClass:
                                                          "absolute right-0 cursor-pointer",
                                                        class: {
                                                          "transform rotate-180":
                                                            _vm.childCheckboxOpened
                                                        },
                                                        attrs: {
                                                          src: require("../../images/icon-chevron-checkbox.svg"),
                                                          alt: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.toggleChildCheckbox()
                                                          }
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              Object.values(programma.children)
                                                .length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        hidden: !_vm.childCheckboxOpened
                                                      }
                                                    },
                                                    _vm._l(
                                                      Object.values(
                                                        programma.children
                                                      ),
                                                      function(child, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "flex items-start ml-8 mt-3"
                                                          },
                                                          [
                                                            _c("input", {
                                                              attrs: {
                                                                type:
                                                                  "checkbox",
                                                                name:
                                                                  "child_programma-" +
                                                                  child.parent +
                                                                  "-" +
                                                                  index,
                                                                id:
                                                                  "child_programma-" +
                                                                  child.parent +
                                                                  "-" +
                                                                  index
                                                              },
                                                              domProps: {
                                                                checked: _vm.checkIfSelected(
                                                                  "programma",
                                                                  child.term_id
                                                                ),
                                                                value:
                                                                  child.term_id
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.selectFilter(
                                                                    "programma",
                                                                    child.term_id
                                                                  )
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("label", {
                                                              attrs: {
                                                                for:
                                                                  "child_programma-" +
                                                                  child.parent +
                                                                  "-" +
                                                                  index
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("label", {
                                                              class: {
                                                                active: _vm.checkIfSelected(
                                                                  "programma",
                                                                  child.term_id
                                                                )
                                                              },
                                                              attrs: {
                                                                for:
                                                                  "child_programma-" +
                                                                  child.parent +
                                                                  "-" +
                                                                  index
                                                              },
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  child.name
                                                                )
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "voor-section filter-group"
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "mb-2 text-18px font-bold"
                                        },
                                        [_vm._v("Doelgroep")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.eventOptions.doelgroep,
                                        function(doel, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "sm:whitespace-normal flex items-start text-16px mb-3"
                                            },
                                            [
                                              _c("input", {
                                                attrs: {
                                                  type: "checkbox",
                                                  name:
                                                    "doelgroepfilter" + index,
                                                  id: "doelgroepfilter" + index
                                                },
                                                domProps: {
                                                  checked: _vm.checkIfSelected(
                                                    "doelgroep",
                                                    doel.term_id
                                                  ),
                                                  value: doel.term_id
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.selectFilter(
                                                      "doelgroep",
                                                      doel.term_id
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("label", {
                                                attrs: {
                                                  for: "doelgroepfilter" + index
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("label", {
                                                class: {
                                                  active: _vm.checkIfSelected(
                                                    "doelgroep",
                                                    doel.term_id
                                                  )
                                                },
                                                attrs: {
                                                  for: "doelgroepfilter" + index
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(doel.name)
                                                }
                                              })
                                            ]
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "voor-section filter-group"
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "mb-2 text-18px font-bold"
                                        },
                                        [_vm._v("Bijzonderheden")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.detailsOptions, function(
                                        detail,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "sm:whitespace-normal flex items-start text-16px mb-3"
                                          },
                                          [
                                            _c("input", {
                                              attrs: {
                                                type: "checkbox",
                                                name: "detailfilter" + index,
                                                id: "detailfilter" + index
                                              },
                                              domProps: {
                                                checked: _vm.checkIfSelected(
                                                  "details",
                                                  detail.value
                                                ),
                                                value: detail.value
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectFilter(
                                                    "details",
                                                    detail.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              attrs: {
                                                for: "detailfilter" + index
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              class: {
                                                active: _vm.checkIfSelected(
                                                  "details",
                                                  detail.value
                                                )
                                              },
                                              attrs: {
                                                for: "detailfilter" + index
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(detail.label)
                                              }
                                            })
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "delneemers-section hidden filter-group mb-8 sm:mb-0"
                                    },
                                    [
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "mb-2 text-18px font-bold"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Excursiedeelnemers\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.deelnemersOptions, function(
                                        deel,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "sm:whitespace-normal flex items-start text-16px mb-3"
                                          },
                                          [
                                            _c("input", {
                                              attrs: {
                                                type: "checkbox",
                                                name: "deelfilter-mobi" + index,
                                                id: "deelfilter-mobi" + index
                                              },
                                              domProps: {
                                                checked: _vm.checkIfSelected(
                                                  "deelnemers",
                                                  deel.deelnemerid
                                                ),
                                                value: deel.deelnemerid
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectFilter(
                                                    "deelnemers",
                                                    deel.deelnemerid
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              attrs: {
                                                for: "deelfilter-mobi" + index
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              class: {
                                                active: _vm.checkIfSelected(
                                                  "deelnemers",
                                                  deel.deelnemerid
                                                )
                                              },
                                              attrs: {
                                                for: "deelfilter-mobi" + index
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(deel.title)
                                              }
                                            })
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "filters-form flex" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "right-side w-full flex flex-col sm:flex-row justify-center items-center"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "w-full sm:w-2/5 py-2 lg:py-4 px-3 lg:px-6 sm:w-auto text-gulfBlue font-semibold lg:font-bold hover:opacity-50 focus:outline-none",
                                        on: {
                                          click: function($event) {
                                            return _vm.clearAllFilters("mobile")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      Filters wissen\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "w-full sm:w-3/5 sm:w-auto bg-gulfBlue py-2 lg:py-4 px-3 lg:px-6 text-white font-semibold lg:font-bold mt-2 sm:mt-0 sm:ml-4 focus:outline-none",
                                        on: {
                                          click: function($event) {
                                            return _vm.loadProgrammes(
                                              false,
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "hover:opacity-75" },
                                          [_vm._v("Filters toepassen")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "px-4 w-full mb-4" }, [
                _c(
                  "div",
                  { staticClass: "hidden lg:block" },
                  _vm._l(this.eventOptions.programma, function(
                    programma,
                    index
                  ) {
                    return _c(
                      "button",
                      {
                        key: index,
                        staticClass: "exclusive-filters",
                        class: [
                          "blue-hover cursor-pointer",
                          {
                            programmaSelected: _vm.checkIfSelected(
                              "programma",
                              programma.term_id
                            )
                          }
                        ],
                        on: {
                          click: function($event) {
                            return _vm.selectFilter(
                              "programma",
                              programma.term_id,
                              true
                            )
                          },
                          mouseover: function($event) {
                            _vm.hoveredExFilter = programma.term_id
                          },
                          mouseleave: function($event) {
                            _vm.hoveredExFilter = undefined
                          }
                        }
                      },
                      [
                        _vm.checkIfSelected("programma", programma.term_id) ===
                          undefined && _vm.hoveredExFilter
                          ? [
                              programma.icon_white.length > 0 ||
                              programma.icon_grey.length > 0
                                ? [
                                    _c("img", {
                                      staticClass: "mr-2 w-6",
                                      attrs: {
                                        src:
                                          programma.term_id ===
                                          _vm.hoveredExFilter
                                            ? programma.icon_white
                                            : programma.icon_grey
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ]
                          : [
                              _vm.checkIfSelected(
                                "programma",
                                programma.term_id
                              )
                                ? _c("img", {
                                    class: programma.icon_white && "mr-2 w-6",
                                    attrs: {
                                      src: programma.icon_white,
                                      alt: ""
                                    }
                                  })
                                : _c("img", {
                                    class: [
                                      programma.icon_grey && "mr-2 w-6",
                                      {
                                        hidden: _vm.checkIfSelected(
                                          "programma",
                                          programma.term_id
                                        )
                                      }
                                    ],
                                    attrs: { src: programma.icon_grey, alt: "" }
                                  })
                            ],
                        _vm._v(
                          "\n            " +
                            _vm._s(programma.name) +
                            "\n          "
                        )
                      ],
                      2
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hidden lg:block px-4 w-full mb-4 md:mb-0" },
                [
                  _c("div", { staticClass: "views-section" }, [
                    _c("div", { staticClass: "flex justify-end" }, [
                      _c("div", { staticClass: "toggle-view flex text-18px" }, [
                        _c(
                          "div",
                          { staticClass: "py-2 px-4 flex items-center" },
                          [_vm._v("Weergave")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            {
                              staticClass: "toggle-btn py-2 px-4",
                              class: { active: this.view === "list" },
                              on: {
                                click: function($event) {
                                  return _vm.toggleViews("list")
                                }
                              }
                            },
                            [
                              this.view === "list"
                                ? _c("img", {
                                    staticClass: "inline-block",
                                    attrs: {
                                      src: require("../../images/icon-list-blue.svg"),
                                      alt: ""
                                    }
                                  })
                                : _c("img", {
                                    staticClass: "inline-block",
                                    attrs: {
                                      src: require("../../images/icon-list-grey.svg"),
                                      alt: ""
                                    }
                                  }),
                              _vm._v(
                                "\n                  Lijst\n                "
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.noData
      ? _c("div", [_vm._m(4)])
      : _c("div", { staticClass: "py-4 lg:py-8" }, [
          _vm.loading
            ? _c("div", { staticClass: "flex justify-center items-center" }, [
                _c("div", { staticClass: "donut multi" })
              ])
            : _c("div", { staticClass: "programmeCards flex flex-wrap" }, [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "div",
                    { staticClass: "-mx-4 flex flex-wrap justify-start" },
                    [
                      !_vm.tickets_sales_start
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "vue-card px-4 w-full sm:w-1/2 lg:w-1/3 mb-8"
                            },
                            [
                              _c("TicketverkoopCard", {
                                attrs: {
                                  "ticket-start-date": _vm.ticketStartDate
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.data, function(d, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "vue-card px-4 w-full sm:w-1/2 lg:w-1/3 mb-4 sm:mb-8",
                            attrs: { "data-id": d.postid }
                          },
                          [_c("event-card", { attrs: { data: d } })],
                          1
                        )
                      }),
                      _vm._v(" "),
                      this.whdThuisSelected
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "vue-card px-4 w-full sm:w-1/2 lg:w-1/3 mb-8"
                            },
                            [_c("WhdThuisCard")],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ])
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-center pb-20" }, [
      !_vm.loadMoreClicked && _vm.navigation && !_vm.loading && !_vm.noData
        ? _c("div", { staticClass: "flex items-center" }, [
            _c(
              "button",
              {
                staticClass:
                  "button bg-blue cursor-pointer bg-blueDark text-white",
                on: {
                  click: function($event) {
                    return _vm.loadMore()
                  }
                }
              },
              [_vm._v("\n        Toon meer\n      ")]
            )
          ])
        : _vm.loadMoreClicked && _vm.navigation
        ? _c("div", { staticClass: "flex justify-center items-center" }, [
            _c("div", { staticClass: "donut multi" })
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-left w-full lg:w-auto" }, [
      _c(
        "h1",
        {
          staticClass:
            "heading font-whd text-gulfBlue text-50px md:text-70px lg:text-90px sm:mb-2 md:mb-4 lg:mb-6"
        },
        [_vm._v("\n          Programma\n        ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "w-5/6 sm:w-3/4 text-bluePersian whitespace-no-wrap px-6 py-4 lg:py-4 flex justify-start sm:justify-center items-center"
      },
      [
        _c("img", {
          staticClass: "mr-2",
          attrs: { src: require("../../images/icon-filters-blue.svg"), alt: "" }
        }),
        _vm._v("\n                  Uitgebreid zoeken\n                ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "w-5/6 whitespace-no-wrap text-bluePersian px-5 lg:py-4 flex justify-start sm:justify-center items-center"
      },
      [
        _c("img", {
          staticClass: "w-4 lg:w-5 mr-1",
          attrs: { src: require("../../images/icon-filters-blue.svg"), alt: "" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "block sm:hidden" }, [_vm._v("Filters")]),
        _vm._v(" "),
        _c("span", { staticClass: "hidden sm:block" }, [
          _vm._v("Uitgebreid zoeken")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticClass: "w-4 lg:w-5 mr-2",
        attrs: { src: require("../../images/icon-filters-blue.svg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "py-32 text-center" }, [
        _vm._v(
          "\n        Geen evenementen gevonden. Probeer het alstublieft opnieuw.\n      "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/johntanyuehan/Workspace/devilbox/data/www/whd/htdocs/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/johntanyuehan/Workspace/devilbox/data/www/whd/htdocs/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib?{}!./scripts/vue/ProgrammaComponent.vue?vue&type=template&id=b419c00e&
// module id = 72
// module chunks = 0